import { AxiosRequestConfig } from 'axios';

const TOKEN_PREFIX = 'Bearer ';
const INVALID_TOKEN_LITERALS = ['null', 'undefined'];

export function effectiveBearerTokenValue(token: any): string | null {
  if (token == null) return null;

  const trimmedToken = String(token).trim();
  if (!trimmedToken || INVALID_TOKEN_LITERALS.includes(trimmedToken.toLowerCase())) {
    return null;
  }

  let tokenValue = trimmedToken;
  while (tokenValue.toLowerCase().startsWith(TOKEN_PREFIX.toLowerCase())) {
    tokenValue = tokenValue.slice(TOKEN_PREFIX.length).trim();
  }

  if (!tokenValue || INVALID_TOKEN_LITERALS.includes(tokenValue.toLowerCase())) {
    return null;
  }

  return tokenValue;
}

export function hasEffectiveBearerToken(token: any): boolean {
  return effectiveBearerTokenValue(token) != null;
}

export function effectiveAuthorizationHeader(token: any): string | null {
  const tokenValue = effectiveBearerTokenValue(token);
  return tokenValue ? `${TOKEN_PREFIX}${tokenValue}` : null;
}

export function applyBearerOrCookie(
  baseConfig: AxiosRequestConfig = {},
  bearerTokenString: any = null,
): AxiosRequestConfig {
  const mergedConfig: AxiosRequestConfig = {
    ...baseConfig,
    headers: { ...(baseConfig.headers || {}) },
    withCredentials: true,
  };

  const headers = mergedConfig.headers as Record<string, any>;
  delete headers.Authorization;

  const authorizationHeader = effectiveAuthorizationHeader(bearerTokenString);
  if (authorizationHeader) {
    headers.Authorization = authorizationHeader;
  }

  return mergedConfig;
}
